import { __assign, __awaiter, __generator, __values } from "tslib";
import { app } from '@ekuaibao/whispered';
import { FMP_MONITOR_CONFIG_MAP } from './FMPConfigMap';
import { addRumAction } from '../hosting/dataflux-rum';
export var getTrueKey = function (key) {
    if (key === void 0) { key = ''; }
    var arr = key.split('_');
    if (arr.length === 3) {
        return arr[2];
    }
    else if (arr.length > 3) {
        return arr.splice(2).join('_');
    }
    else {
        return key;
    }
};
export var fixEntityObj = function (it) {
    if (!it) {
        return it;
    }
    var obj = {};
    Object.keys(it).forEach(function (key) {
        var tKey = getTrueKey(key);
        obj[tKey] = it[key];
    });
    return obj;
};
function getPerformanceMarkTime(markName) {
    var _a, _b;
    var time = (_b = (_a = performance.getEntriesByName(markName)) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.startTime;
    return time ? Math.floor(time) : null;
}
var fmpMonitorState = {
    isActive: false,
    hasCollectedPages: new Set(),
    observer: null,
    timeoutId: null,
    currentPage: '',
    startTime: 0,
    hadHiddenDuringFMP: false,
    hadPageHideDuringFMP: false,
    hadWindowBlurDuringFMP: false,
    firstHiddenAt: null,
    firstPageHideAt: null,
    firstWindowBlurAt: null
};
function markFMPVisibilityInterrupted(type) {
    var _a, _b, _c;
    var currentTime = Math.floor(performance.now());
    if (type === 'hidden') {
        fmpMonitorState.hadHiddenDuringFMP = true;
        fmpMonitorState.firstHiddenAt = (_a = fmpMonitorState.firstHiddenAt) !== null && _a !== void 0 ? _a : currentTime;
    }
    else if (type === 'pagehide') {
        fmpMonitorState.hadPageHideDuringFMP = true;
        fmpMonitorState.firstPageHideAt = (_b = fmpMonitorState.firstPageHideAt) !== null && _b !== void 0 ? _b : currentTime;
    }
    else {
        fmpMonitorState.hadWindowBlurDuringFMP = true;
        fmpMonitorState.firstWindowBlurAt = (_c = fmpMonitorState.firstWindowBlurAt) !== null && _c !== void 0 ? _c : currentTime;
    }
}
function resetFMPVisibilityState() {
    fmpMonitorState.hadHiddenDuringFMP = false;
    fmpMonitorState.hadPageHideDuringFMP = false;
    fmpMonitorState.hadWindowBlurDuringFMP = false;
    fmpMonitorState.firstHiddenAt = null;
    fmpMonitorState.firstPageHideAt = null;
    fmpMonitorState.firstWindowBlurAt = null;
}
function cleanupFMP() {
    if (fmpMonitorState.observer) {
        fmpMonitorState.observer.disconnect();
        fmpMonitorState.observer = null;
    }
    if (fmpMonitorState.timeoutId) {
        clearTimeout(fmpMonitorState.timeoutId);
        fmpMonitorState.timeoutId = null;
    }
    app.un('hash:change', handleRouteChange);
    document.removeEventListener('visibilitychange', handleVisibilityChange);
    window.removeEventListener('pagehide', handleVisibilityChange);
    window.removeEventListener('blur', handleWindowBlur);
    fmpMonitorState.isActive = false;
    console.log('FMP监控已清理:', fmpMonitorState.currentPage);
}
function handleVisibilityChange(event) {
    if ((event === null || event === void 0 ? void 0 : event.type) === 'pagehide') {
        markFMPVisibilityInterrupted('pagehide');
        cleanupFMP();
        return;
    }
    if (document.visibilityState === 'hidden') {
        markFMPVisibilityInterrupted('hidden');
        cleanupFMP();
    }
}
function handleWindowBlur() {
    if (fmpMonitorState.isActive) {
        markFMPVisibilityInterrupted('blur');
    }
}
function handleRouteChange() {
    var currentHash = location.hash.slice(1);
    if (fmpMonitorState.isActive && fmpMonitorState.currentPage !== currentHash) {
        console.log('路由从', fmpMonitorState.currentPage, '变化到', currentHash, '，停止FMP监控');
        cleanupFMP();
    }
}
var monitorFMP = function (options, pageHash) {
    if (!('MutationObserver' in window)) {
        return;
    }
    if (fmpMonitorState.hasCollectedPages.has(pageHash)) {
        console.log('页面FMP数据已采集，跳过重复监控:', pageHash);
        return;
    }
    if (fmpMonitorState.isActive) {
        cleanupFMP();
    }
    var isFMPNode = options.isFMPNode, params = options.params;
    try {
        if (document.visibilityState === 'hidden') {
            return;
        }
        resetFMPVisibilityState();
        fmpMonitorState.currentPage = pageHash;
        fmpMonitorState.startTime = performance.now();
        app.on('hash:change', handleRouteChange);
        document.addEventListener('visibilitychange', handleVisibilityChange);
        window.addEventListener('pagehide', handleVisibilityChange);
        window.addEventListener('blur', handleWindowBlur);
        fmpMonitorState.observer = new MutationObserver(function (mutations) {
            var e_1, _a, e_2, _b;
            try {
                for (var mutations_1 = __values(mutations), mutations_1_1 = mutations_1.next(); !mutations_1_1.done; mutations_1_1 = mutations_1.next()) {
                    var mutation = mutations_1_1.value;
                    try {
                        for (var _c = (e_2 = void 0, __values(Array.from(mutation.addedNodes))), _d = _c.next(); !_d.done; _d = _c.next()) {
                            var node = _d.value;
                            if (node.nodeType !== Node.ELEMENT_NODE) {
                                continue;
                            }
                            if (isFMPNode(node)) {
                                var args = typeof params === 'function' ? params() : params;
                                var loadedDuration = Math.floor(performance.now());
                                var currentVisibilityState = document.visibilityState;
                                var isWindowFocused = typeof document.hasFocus === 'function' ? document.hasFocus() : null;
                                var hadHiddenDuringFMP = fmpMonitorState.hadHiddenDuringFMP || currentVisibilityState === 'hidden';
                                var hadVisibilityInterruptionDuringFMP = hadHiddenDuringFMP ||
                                    fmpMonitorState.hadPageHideDuringFMP ||
                                    fmpMonitorState.hadWindowBlurDuringFMP ||
                                    isWindowFocused === false;
                                addRumAction('first_meaning_paint', __assign(__assign({}, args), { loadedDuration: loadedDuration,
                                    pageHash: pageHash, monitorStartTime: fmpMonitorState.startTime, visibilityState: currentVisibilityState, isWindowFocused: isWindowFocused,
                                    hadHiddenDuringFMP: hadHiddenDuringFMP, hadPageHideDuringFMP: fmpMonitorState.hadPageHideDuringFMP, hadWindowBlurDuringFMP: fmpMonitorState.hadWindowBlurDuringFMP, hadVisibilityInterruptionDuringFMP: hadVisibilityInterruptionDuringFMP, firstHiddenAt: fmpMonitorState.firstHiddenAt, firstPageHideAt: fmpMonitorState.firstPageHideAt, firstWindowBlurAt: fmpMonitorState.firstWindowBlurAt, mfeLoadStart: getPerformanceMarkTime('mfeLoadStart'), mfeLoadEnd: getPerformanceMarkTime('mfeLoadEnd'), appRenderStart: getPerformanceMarkTime('appRenderStart'), appCallbackStart: getPerformanceMarkTime('appCallbackStart'), appCallbackEnd: getPerformanceMarkTime('appCallbackEnd'), renderAsAppStart: getPerformanceMarkTime('renderAsAppStart'), renderAsAppEnd: getPerformanceMarkTime('renderAsAppEnd'), fmpPrefetchStart: getPerformanceMarkTime('fmpPrefetchStart'), fmpPrefetchEnd: getPerformanceMarkTime('fmpPrefetchEnd'), fmpPrefetchMenuPowerStart: getPerformanceMarkTime('fmpPrefetchMenuPowerStart'), fmpPrefetchMenuPowerEnd: getPerformanceMarkTime('fmpPrefetchMenuPowerEnd'), fmpPrefetchMenuListStart: getPerformanceMarkTime('fmpPrefetchMenuListStart'), fmpPrefetchMenuListEnd: getPerformanceMarkTime('fmpPrefetchMenuListEnd'), fmpPrefetchHomepageCardsStart: getPerformanceMarkTime('fmpPrefetchHomepageCardsStart'), fmpPrefetchHomepageCardsEnd: getPerformanceMarkTime('fmpPrefetchHomepageCardsEnd'), fmpPrefetchHomepageMyBillsStart: getPerformanceMarkTime('fmpPrefetchHomepageMyBillsStart'), fmpPrefetchHomepageMyBillsEnd: getPerformanceMarkTime('fmpPrefetchHomepageMyBillsEnd'), fmpPrefetchBillsListStart: getPerformanceMarkTime('fmpPrefetchBillsListStart'), fmpPrefetchBillsListEnd: getPerformanceMarkTime('fmpPrefetchBillsListEnd'), appRenderEnd: getPerformanceMarkTime('appRenderEnd') }));
                                console.log(args.title, 'FMP - 首次加载完成:', {
                                    pageHash: pageHash,
                                    duration: loadedDuration,
                                    startTime: fmpMonitorState.startTime,
                                });
                                app.emit('fmp-finished');
                                fmpMonitorState.hasCollectedPages.add(pageHash);
                                cleanupFMP();
                                return;
                            }
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (mutations_1_1 && !mutations_1_1.done && (_a = mutations_1.return)) _a.call(mutations_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        });
        fmpMonitorState.observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        fmpMonitorState.timeoutId = setTimeout(function () {
            console.log('FMP监控超时:', pageHash);
            cleanupFMP();
        }, 60 * 1000);
        fmpMonitorState.isActive = true;
        console.log('FMP监控已启动:', pageHash);
    }
    catch (error) {
        console.error('FMP监控启动失败:', error);
    }
};
export var trackFMP = function (hash) { return __awaiter(void 0, void 0, void 0, function () {
    var config;
    return __generator(this, function (_a) {
        if (!hash) {
            return [2];
        }
        if (typeof hash === 'string') {
            hash = hash.replace('#', '');
        }
        config = Object.values(FMP_MONITOR_CONFIG_MAP).find(function (config) { return config.rule(hash); });
        if (config) {
            monitorFMP({
                isFMPNode: config.isFMPNode,
                params: config.params
            }, hash);
        }
        return [2];
    });
}); };
export var FMPUtils = {
    getState: function () { return ({
        isActive: fmpMonitorState.isActive,
        hasCollectedPages: Array.from(fmpMonitorState.hasCollectedPages),
        currentPage: fmpMonitorState.currentPage
    }); },
    reset: function () {
        cleanupFMP();
        fmpMonitorState.hasCollectedPages.clear();
    },
    cleanup: cleanupFMP
};
export var registerDingtalkPerformance = function () {
    try {
        if (process.env.NODE_ENV === 'production' && location.hostname === 'dd2.hosecloud.com') {
            window.__BIRD_CONFIG = window.__BIRD_CONFIG || {};
            window.__BIRD_CONFIG.tags = {
                isvAppId: '2297'
            };
            var reportPerformance = function () {
                setTimeout(function () {
                    var send = (window.__BIRD || {}).send;
                    window.performance && window.performance.mark('FMP');
                    typeof send === 'function' && send();
                }, 500);
            };
            if (document.readyState === 'complete') {
                reportPerformance();
            }
            else {
                window.addEventListener('load', reportPerformance);
            }
        }
    }
    catch (e) { }
};
